import { getQueryFilter } from '@skytech/utils'

import { DEVICE_ORDER_STATUS_ID } from '@/modules/applications/device/constants'

import type { DeviceApplication } from '../types'

const stringMatcher = (application: DeviceApplication) => [application.model, application.name]

export const getFilteredList = ({
  statusFilter,
  searchFilter,
  deviceApplicationList,
}: {
  statusFilter: number
  searchFilter: string
  deviceApplicationList: DeviceApplication[]
}) => {
  if (statusFilter === DEVICE_ORDER_STATUS_ID.ALL && !searchFilter) return deviceApplicationList
  if (statusFilter === DEVICE_ORDER_STATUS_ID.ALL) {
    return deviceApplicationList.filter(getQueryFilter(searchFilter, stringMatcher))
  }

  if (statusFilter === DEVICE_ORDER_STATUS_ID.AT_VENDOR) {
    return deviceApplicationList.filter(
      application =>
        [
          DEVICE_ORDER_STATUS_ID.PROCESSED,
          DEVICE_ORDER_STATUS_ID.PROCESSING,
          DEVICE_ORDER_STATUS_ID.IN_ECOM,
        ].includes(application.status) && getQueryFilter(searchFilter, stringMatcher)(application)
    )
  }

  if (statusFilter === DEVICE_ORDER_STATUS_ID.OPEN) {
    return deviceApplicationList.filter(
      application =>
        [
          DEVICE_ORDER_STATUS_ID.PROCESSED,
          DEVICE_ORDER_STATUS_ID.PROCESSING,
          DEVICE_ORDER_STATUS_ID.NEW,
        ].includes(application.status) && getQueryFilter(searchFilter, stringMatcher)(application)
    )
  }

  return deviceApplicationList.filter(
    application =>
      application.status === statusFilter &&
      getQueryFilter(searchFilter, stringMatcher)(application)
  )
}
